import { Grid } from "@mui/material";
import { useSelector } from "react-redux";
import { useState, useEffect, Fragment } from "react";

import CampaignStatus from "../Status";
import FormEighth from "./SelectCampaignChannel";
import FormOne from "./CreateCampaignFirstForm";
import FormTwo from "./CreateCampaignSecondForm";
import FormThird from "./CreateCampaignThirdForm";
import CampaignLiveUser from "../CampaignLiveUser";
import FormSeventh from "./PreferredCampaignChannel";
import UploadCSV from "../../uploadCSV dailog/UploadCSV";
import AdminCampaignStatus from "../AdminCampaignStatus";
import CampaignButtons from "./../CreateCampaignButtons";
import ShowAudienceSizeDialog from "../ShowAudienceSize";
import EditButtons from "../../../../components/EditButtons";
import TakeUpDialog from "../../take up offer components/TakeUpDailog";
import { ButtonFooter } from "../../../../components";
import RejectOfferDialog from "../../reject offer components/RejectOfferDialog";
import BrandDetailsDialog from "../../brand details components/BrandDetailsDialog";
import BroadcastReportDialog from "../../broadcast report dialog component/BroadcastReportDialog";
import Connections from "../../superadmin campaign details component/ConnectionList";
import SubNavbar from "../../../../components/SubNavbar";
import { useAxios } from "../../../../hooks";

export default function FormDisplay({
  agentToken,
  setAgentToken,
  agents,
  audiences,
  editState,
  liveUsers,
  categories,
  rejectOffer,
  formikProps,
  takeUpOffer,
  audienceData,
  setEditState,
  component = "",
  brandDetails,
  setTakeUpOffer,
  setBrandDetails,
  setRejectOffer,
  setAudienceData,
  setAudienceCreated,
  preferredChannels,
  connectionList,
}) {
  const axios = useAxios();
  const [audienceSize, setAudienceSize] = useState({
    values: {},
  });
  const [brandIdentity, setBrandIdentity] = useState(false);
  const [dialogUploadCSV, setDialogUploadCSV] = useState(false);
  const [broadcastReportDialog, setBroadcastReportDialog] = useState(false);

  const { activeBrand } = useSelector((state) => state.memberDetails);

  useEffect(() => {
    if (formikProps.values.brandID) {
      if (parseInt(formikProps.values.brandID) !== parseInt(activeBrand.ID)) {
        setBrandIdentity(true);
      }
    }
  }, [formikProps.values.brandID, activeBrand.ID]);

  useEffect(() => {
    axios({
      url: "/get/audienceSizing",
      method: "POST",
      data: {
        brand_id: parseInt(activeBrand.ID),
        campaign_id: parseInt(formikProps.values.campaignID),
        audience_id: parseInt(audienceData.ID),
      },
      disableRedirect: true,
      disableError: true,
    }).then((audienceSize) => {
      if (audienceSize.status) {
        setAudienceSize(() => ({
          values: {
            audience_params: audienceSize.data?.audience_params,
            audience_size: audienceSize.data?.audience_size,
            audience_pricing: audienceSize.data?.audience_pricing,
            distinctCategories: audienceSize.data?.distinctCategories,
          },
        }));
      }
    });
  }, [activeBrand.ID, formikProps.values.campaignID, audienceData.ID, axios]);

  return (
    <Grid container spacing={4}>
      <Grid size={12}>
        <SubNavbar
          pageName={`Campaign Details`}
          buttons={[
            <CampaignButtons
              ID={formikProps.values.campaignID}
              editState={editState}
              liveUsers={liveUsers}
              setEditState={setEditState}
              formikProps={formikProps}
              component={component}
              brandIdentity={brandIdentity}
              setTakeUpOffer={setTakeUpOffer}
              setDialogUploadCSV={setDialogUploadCSV}
              setBroadcastReportDialog={setBroadcastReportDialog}
            />,
          ]}
        />
      </Grid>

      {component !== "" &&
        formikProps.values.campaignStatus !== "REQUESTED" && (
          <Grid size={12}>
            <CampaignStatus
              formikProps={formikProps}
              setTakeUpOffer={setTakeUpOffer}
            />
          </Grid>
        )}

      {component === "" && (
        <Grid size={12}>
          <AdminCampaignStatus
            preferredChannels={preferredChannels}
            audienceSize={audienceSize}
            formikProps={formikProps}
          />
        </Grid>
      )}

      {component === "" &&
        formikProps.values.permissionSettings?.connection_list && (
          <Connections connections={connectionList} formikProps={formikProps} />
        )}

      <Fragment>
        <FormOne
          categories={categories}
          brandDetails={brandDetails}
          setBrandDetails={setBrandDetails}
          formikProps={formikProps}
          editState={editState}
          component={component}
          brandIdentity={brandIdentity}
        />

        <Grid size={12} />

        <FormTwo
          audienceSize={audienceSize}
          setAudienceData={setAudienceData}
          formikProps={formikProps}
          audiences={audiences}
          editState={editState}
          component={component}
          brandIdentity={brandIdentity}
          audienceData={audienceData}
          setAudienceCreated={setAudienceCreated}
        />

        <Grid size={12} />

        <FormThird
          brandIdentity={brandIdentity}
          formikProps={formikProps}
          editState={editState}
          component={component}
        />

        <Grid size={12} />

        {component !== "request" && (
          <Fragment>
            <Grid size={12} />

            <FormSeventh
              editState={editState}
              formikProps={formikProps}
              preferredChannels={preferredChannels}
            />

            <FormEighth
              agentToken={agentToken}
              agents={agents}
              setAgentToken={setAgentToken}
              formikProps={formikProps}
              editState={editState}
            />
          </Fragment>
        )}

        {editState && (
          <Grid size={12}>
            <ButtonFooter
              ID={formikProps.values.campaignID}
              editState={editState}
              setEditState={setEditState}
              formikProps={formikProps}
            />
          </Grid>
        )}

        {!!(
          audienceSize?.values?.audience_params ||
          audienceSize?.values?.audience_size
        ) && <ShowAudienceSizeDialog audienceID={audienceData.ID} />}

        {brandIdentity && (
          <CampaignLiveUser
            takeUpOffer={takeUpOffer}
            liveUsers={liveUsers}
            component={component}
          />
        )}
      </Fragment>

      <RejectOfferDialog reject={rejectOffer} setReject={setRejectOffer} />

      <TakeUpDialog
        takeUp={takeUpOffer}
        formikProps={formikProps}
        setTakeUp={setTakeUpOffer}
      />

      <BrandDetailsDialog details={brandDetails} setDetails={setBrandDetails} />

      <UploadCSV
        dialogUploadCSV={dialogUploadCSV}
        setDialogUploadCSV={setDialogUploadCSV}
        formikProps={formikProps}
      />

      <BroadcastReportDialog
        broadcastReportDialog={broadcastReportDialog}
        setBroadcastReportDialog={setBroadcastReportDialog}
      />
    </Grid>
  );
}
